export const categories = [
  {
    id: 1,
    name: "Shoes",
    namePt: "Tênis",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Studio%20product%20photography%20of%20a%20pair%20of%20trendy%20chunky%20dad%20sneakers%20in%20pastel%20mint%20green%20and%20white%20colorway%20standing%20on%20a%20light%20sand%20colored%20surface%2C%20bright%20natural%20daylight%20from%20above%2C%20minimalist%20editorial%20composition%2C%20warm%20creamy%20background%20blur%2C%20high%20fashion%20product%20shot%2C%20ultra%20sharp%20textile%20texture&width=600&height=400&seq=cat-v2-shoes-x1k9&orientation=landscape",
    tag: "Popular"
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    namePt: "Moletons",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Fashion%20editorial%20photograph%20of%20a%20plush%20lavender%20gray%20oversized%20pullover%20hoodie%20hanging%20on%20a%20minimalist%20wooden%20hanger%20against%20a%20soft%20peach%20toned%20wall%2C%20gentle%20morning%20sunlight%20casting%20delicate%20shadows%2C%20Scandinavian%20interior%20vibe%2C%20clean%20relaxed%20aesthetic%2C%20visible%20knit%20texture&width=600&height=400&seq=cat-v2-hoodie-m3p7&orientation=landscape",
    tag: "Trending"
  },
  {
    id: 3,
    name: "T-Shirts",
    namePt: "Camisetas",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Bright%20studio%20product%20shot%20of%20a%20vibrant%20coral%20orange%20heavyweight%20cotton%20tee%20shirt%20elegantly%20folded%20on%20a%20pale%20oatmeal%20linen%20background%2C%20warm%20golden%20hour%20side%20lighting%2C%20minimalist%20editorial%20fashion%20photography%2C%20clean%20sharp%20folds%2C%20saturated%20summery%20color%20palette&width=600&height=400&seq=cat-v2-tshirt-r5n2&orientation=landscape",
    tag: ""
  },
  {
    id: 4,
    name: "Jackets",
    namePt: "Jaquetas",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Lifestyle%20product%20photography%20of%20a%20lightweight%20tan%20overshirt%20jacket%20with%20utility%20pockets%20displayed%20on%20a%20clean%20white%20concrete%20surface%2C%20natural%20sunlight%20through%20a%20large%20window%2C%20modern%20urban%20editorial%20style%2C%20warm%20earthy%20tones%2C%20crisp%20fabric%20details%2C%20aesthetic%20flatlay&width=600&height=400&seq=cat-v2-jacket-w8b4&orientation=landscape",
    tag: ""
  },
  {
    id: 5,
    name: "Pants/Shorts",
    namePt: "Calças/Bermudas",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Neatly%20styled%20product%20photograph%20of%20wide%20leg%20cream%20colored%20linen%20trousers%20laid%20flat%20on%20a%20warm%20terracotta%20tiled%20floor%2C%20soft%20afternoon%20sunlight%20streaming%20diagonally%2C%20Mediterranean%20minimalist%20aesthetic%2C%20casual%20elegance%2C%20natural%20fabric%20wrinkles%2C%20warm%20neutral%20color%20harmony&width=600&height=400&seq=cat-v2-pants-d2f6&orientation=landscape",
    tag: ""
  },
  {
    id: 6,
    name: "Headwear",
    namePt: "Acessórios de Cabeça",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20a%20soft%20dusty%20rose%20bucket%20hat%20resting%20on%20a%20smooth%20blonde%20wooden%20table%2C%20dappled%20natural%20light%20through%20leaves%2C%20minimalist%20outdoor%20lifestyle%20aesthetic%2C%20warm%20summer%20vibes%2C%20gentle%20shadows%2C%20subtle%20fabric%20texture%20visible&width=600&height=400&seq=cat-v2-headwear-h7j3&orientation=landscape",
    tag: ""
  },
  {
    id: 7,
    name: "Sets",
    namePt: "Conjuntos",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20of%20a%20coordinated%20sage%20green%20two%20piece%20lounge%20set%20top%20and%20bottoms%20displayed%20together%20on%20a%20minimal%20off%20white%20backdrop%2C%20soft%20diffused%20studio%20lighting%2C%20clean%20modern%20composition%2C%20visible%20ribbed%20texture%2C%20serene%20pastel%20aesthetic&width=600&height=400&seq=cat-v2-sets-k4m8&orientation=landscape",
    tag: "Novo"
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    namePt: "Roupa Íntima",
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Premium%20product%20photography%20of%20soft%20modal%20fabric%20boxer%20briefs%20in%20charcoal%20gray%20neatly%20arranged%20on%20a%20warm%20cream%20marble%20surface%2C%20gentle%20side%20lighting%2C%20luxury%20minimalist%20editorial%20style%2C%20clean%20elegant%20composition%2C%20subtle%20fabric%20sheen%2C%20neutral%20sophisticated%20tones&width=600&height=400&seq=cat-v2-underwear-p9t1&orientation=landscape",
    tag: ""
  },
  {
    id: 9,
    name: "Jersey",
    namePt: "Camisas Esportivas",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20product%20shot%20of%20a%20bold%20burgundy%20and%20gold%20athletic%20jersey%20spread%20flat%20on%20a%20dark%20slate%20gray%20surface%2C%20dramatic%20overhead%20spotlight%2C%20sporty%20editorial%20fashion%20aesthetic%2C%20sharp%20contrast%2C%20visible%20mesh%20fabric%20pattern%2C%20energetic%20vibe&width=600&height=400&seq=cat-v2-jersey-s2v5&orientation=landscape",
    tag: ""
  },
  {
    id: 10,
    name: "Accessories",
    namePt: "Acessórios",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Stylish%20flatlay%20photography%20of%20various%20fashion%20accessories%20including%20a%20gold%20chain%20necklace%20and%20minimalist%20rings%20scattered%20on%20a%20blush%20pink%20velvet%20surface%2C%20soft%20natural%20window%20light%2C%20luxury%20editorial%20aesthetic%2C%20warm%20rose%20gold%20tones%2C%20elegant%20composition&width=600&height=400&seq=cat-v2-accessories-f7g4&orientation=landscape",
    tag: ""
  },
  {
    id: 11,
    name: "Bags",
    namePt: "Bolsas",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Product%20photography%20of%20a%20structured%20crossbody%20bag%20in%20caramel%20brown%20genuine%20leather%20placed%20on%20a%20white%20minimalist%20pedestal%2C%20bright%20clean%20studio%20lighting%2C%20high%20end%20fashion%20editorial%2C%20visible%20leather%20grain%20and%20gold%20hardware%2C%20luxury%20minimalist%20composition&width=600&height=400&seq=cat-v2-bags-j1c8&orientation=landscape",
    tag: "Popular"
  },
  {
    id: 12,
    name: "Belts",
    namePt: "Cintos",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20photograph%20of%20a%20sleek%20black%20leather%20belt%20with%20a%20polished%20silver%20buckle%20artfully%20curled%20on%20a%20warm%20gray%20concrete%20surface%2C%20soft%20directional%20lighting%2C%20modern%20minimalist%20editorial%2C%20sharp%20metal%20reflection%2C%20rich%20leather%20texture%2C%20contrast%20tones&width=600&height=400&seq=cat-v2-belts-q3w7&orientation=landscape",
    tag: ""
  },
  {
    id: 13,
    name: "Perfumes",
    namePt: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Luxury%20product%20photography%20of%20a%20frosted%20glass%20perfume%20bottle%20with%20a%20rose%20gold%20cap%20filled%20with%20pale%20pink%20liquid%20placed%20on%20a%20white%20marble%20slab%20with%20fresh%20rose%20petals%20nearby%2C%20bright%20studio%20lighting%2C%20elegant%20beauty%20editorial%2C%20romantic%20soft%20aesthetic&width=600&height=400&seq=cat-v2-perfumes-z6x9&orientation=landscape",
    tag: ""
  },
  {
    id: 14,
    name: "Other Stuff",
    namePt: "Outros Itens",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Cool%20flatlay%20photograph%20of%20various%20lifestyle%20items%20including%20retro%20wayfarer%20sunglasses%20and%20a%20cork%20coaster%20on%20a%20warm%20walnut%20wood%20table%2C%20soft%20morning%20sunlight%2C%20Scandinavian%20minimalist%20aesthetic%2C%20warm%20organic%20composition%2C%20neutral%20earthy%20palette%2C%20clean%20arrangement&width=600&height=400&seq=cat-v2-other-l5e2&orientation=landscape",
    tag: ""
  }
];

export const seoArticlesList = [
  {
    slug: "guia-completo-hoobuyspreadsheet",
    title: "Guia Completo do Hoobuy Spreadsheet 2026",
    subtitle: "Como Encontrar os Melhores Produtos e Economizar",
    excerpt: "Descubra como usar o hoobuyspreadsheet para encontrar produtos virais, comparar preços e fazer compras inteligentes.",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20desk%20workspace%20with%20a%20silver%20laptop%20showing%20a%20colorful%20organized%20spreadsheet%20on%20its%20screen%2C%20a%20ceramic%20coffee%20mug%20nearby%2C%20warm%20cream%20background%2C%20natural%20daylight%20from%20a%20large%20window%2C%20Scandinavian%20office%20aesthetic%2C%20neat%20and%20organized%2C%20editorial%20photography&width=800&height=500&seq=seo-art-v2-main-g8s3&orientation=landscape",
    tag: "Guia Definitivo",
    tagColor: "secondary"
  },
  {
    slug: "hoobuy-finds-produtos-virais",
    title: "Hoobuy Finds: Os Produtos Mais Virais do Momento",
    subtitle: "Lista Atualizada Semanalmente",
    excerpt: "Confira os produtos que estão bombando no hoobuyspreadsheet esta semana. Tênis, streetwear e acessórios em alta.",
    image: "https://readdy.ai/api/search-image?query=Overhead%20flatlay%20photography%20of%20a%20smartphone%20displaying%20a%20shopping%20app%20surrounded%20by%20trendy%20fashion%20accessories%20like%20a%20watch%20and%20bracelet%20on%20a%20light%20beige%20linen%20fabric%2C%20soft%20diffused%20natural%20light%2C%20editorial%20tech%20lifestyle%20aesthetic&width=500&height=350&seq=seo-art-v2-finds-a1n4&orientation=landscape",
    tag: "Tendências",
    tagColor: "accent"
  },
  {
    slug: "melhores-produtos-virais-hoobuy",
    title: "Melhores Produtos Virais do Hoobuy Sheet",
    subtitle: "Top Picks da Comunidade",
    excerpt: "Seleção dos produtos mais bem avaliados pela comunidade hoobuyspreadsheet. Qualidade garantida e preços imbatíveis.",
    image: "https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20streetwear%20items%20including%20a%20denim%20jacket%20and%20sneakers%20arranged%20on%20a%20warm%20terracotta%20surface%2C%20natural%20side%20lighting%2C%20editorial%20fashion%20flatlay%2C%20warm%20urban%20aesthetic%2C%20Scandinavian%20minimalist%20style&width=500&height=350&seq=seo-art-v2-viral-b5k7&orientation=landscape",
    tag: "Top Picks",
    tagColor: "secondary"
  },
  {
    slug: "guia-compras-hoobuy-iniciantes",
    title: "Guia de Compras Hoobuy para Iniciantes",
    subtitle: "Passo a Passo Completo",
    excerpt: "Nunca comprou pelo hoobuyspreadsheet? Este guia explica tudo que você precisa saber para começar com segurança.",
    image: "https://readdy.ai/api/search-image?query=Warm%20photography%20of%20a%20person%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20a%20notepad%20and%20pen%20on%20a%20light%20wooden%20desk%2C%20soft%20afternoon%20sunlight%2C%20cozy%20home%20office%20vibe%2C%20minimalist%20Scandinavian%20interior%2C%20warm%20neutral%20colors&width=500&height=350&seq=seo-art-v2-guide-c3m9&orientation=landscape",
    tag: "Iniciantes",
    tagColor: "accent"
  },
  {
    slug: "hoobuy-seguranca-confiavel",
    title: "Hoobuy é Confiável? Análise Completa 2026",
    subtitle: "Segurança e Transparência",
    excerpt: "Análise detalhada sobre a segurança do hoobuyspreadsheet. Como evitar golpes e fazer compras com tranquilidade.",
    image: "https://readdy.ai/api/search-image?query=Clean%20photography%20of%20a%20padlock%20icon%20on%20a%20smartphone%20screen%20with%20a%20shield%20symbol%20representing%20online%20security%2C%20warm%20cream%20desk%20surface%2C%20soft%20lighting%2C%20minimalist%20tech%20aesthetic%2C%20trust%20and%20safety%20theme&width=500&height=350&seq=seo-art-v2-safety-d7p2&orientation=landscape",
    tag: "Segurança",
    tagColor: "secondary"
  },
  {
    slug: "produtos-baratos-hoobuy-2026",
    title: "Produtos Baratos no Hoobuy: Top 20 Itens",
    subtitle: "Qualidade com Preço Baixo",
    excerpt: "Os 20 produtos com melhor custo-benefício do hoobuyspreadsheet. Streetwear, acessórios e mais com preços incríveis.",
    image: "https://readdy.ai/api/search-image?query=Bright%20product%20photography%20of%20affordable%20stylish%20fashion%20items%20including%20a%20cap%20and%20sunglasses%20on%20a%20clean%20white%20surface%20with%20green%20plant%20nearby%2C%20natural%20daylight%2C%20fresh%20budget%20friendly%20shopping%20aesthetic%2C%20warm%20minimalist%20style&width=500&height=350&seq=seo-art-v2-cheap-e9r4&orientation=landscape",
    tag: "Economia",
    tagColor: "accent"
  },
  {
    slug: "spreadsheet-hoobuy-atualizado-semanal",
    title: "Spreadsheet Hoobuy Atualizado: Novidades da Semana",
    subtitle: "Atualização Semanal",
    excerpt: "Acompanhe as atualizações semanais do hoobuyspreadsheet. Novos produtos, ajustes de preços e tendências fresquinhas.",
    image: "https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20desk%20calendar%20with%20a%20red%20circle%20marking%20a%20date%20next%20to%20a%20laptop%20showing%20a%20spreadsheet%2C%20warm%20cream%20desk%20surface%2C%20natural%20window%20light%2C%20organized%20workspace%20aesthetic%2C%20Scandinavian%20minimalism&width=500&height=350&seq=seo-art-v2-weekly-f1t6&orientation=landscape",
    tag: "Semanal",
    tagColor: "secondary"
  },
  {
    slug: "como-usar-hoobuy-guia-pratico",
    title: "Como Usar o Hoobuy: Guia Prático Atualizado",
    subtitle: "Tutorial Passo a Passo",
    excerpt: "Aprenda a navegar pelo hoobuyspreadsheet como um profissional. Dicas, truques e funcionalidades essenciais explicadas.",
    image: "https://readdy.ai/api/search-image?query=Warm%20photography%20of%20a%20person%20pointing%20at%20a%20laptop%20screen%20showing%20a%20tutorial%20interface%20with%20arrows%20and%20steps%2C%20light%20wooden%20desk%2C%20soft%20daylight%2C%20educational%20vibe%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones&width=500&height=350&seq=seo-art-v2-howto-h3s8&orientation=landscape",
    tag: "Tutorial",
    tagColor: "accent"
  },
  {
    slug: "roupas-streetwear-hoobuy-barato",
    title: "Roupas Streetwear Baratas no Hoobuy Sheet",
    subtitle: "Moda Urbana Acessível",
    excerpt: "As melhores peças de streetwear com preços acessíveis no hoobuyspreadsheet. Looks incríveis sem gastar muito.",
    image: "https://readdy.ai/api/search-image?query=Editorial%20fashion%20flatlay%20of%20urban%20streetwear%20clothing%20items%20including%20a%20graphic%20hoodie%20and%20cargo%20pants%20on%20a%20raw%20concrete%20floor%2C%20natural%20industrial%20lighting%2C%20modern%20urban%20aesthetic%2C%20warm%20neutral%20grays%20and%20earth%20tones&width=500&height=350&seq=seo-art-v2-street-j4w1&orientation=landscape",
    tag: "Streetwear",
    tagColor: "secondary"
  },
  {
    slug: "comparacao-produtos-hoobuy-spreadsheet",
    title: "Comparação de Produtos no Hoobuy Spreadsheet",
    subtitle: "Análise Comparativa Detalhada",
    excerpt: "Comparamos os produtos mais populares do hoobuyspreadsheet lado a lado. Preço, qualidade e tendência em uma tabela completa.",
    image: "https://readdy.ai/api/search-image?query=Clean%20photography%20of%20a%20laptop%20screen%20displaying%20a%20comparison%20table%20with%20product%20images%20and%20ratings%2C%20on%20a%20minimalist%20white%20desk%2C%20soft%20studio%20lighting%2C%20modern%20professional%20aesthetic%2C%20clean%20sharp%20composition&width=500&height=350&seq=seo-art-v2-compare-m6n3&orientation=landscape",
    tag: "Comparação",
    tagColor: "accent"
  },
  {
    slug: "lista-hoobuy-atualizada-2026",
    title: "Lista Hoobuy Atualizada 2026: Catálogo Completo",
    subtitle: "Catálogo Organizado",
    excerpt: "O catálogo completo e organizado do hoobuyspreadsheet 2026. Todas as categorias, produtos e preços em um só lugar.",
    image: "https://readdy.ai/api/search-image?query=Overhead%20flatlay%20of%20a%20printed%20product%20catalog%20magazine%20open%20on%20a%20light%20wood%20table%20surrounded%20by%20small%20fashion%20accessories%2C%20warm%20coffee%20shop%20lighting%2C%20editorial%20lifestyle%20aesthetic%2C%20cozy%20vibe%2C%20neutral%20cream%20and%20wood%20tones&width=500&height=350&seq=seo-art-v2-catalog-p8q5&orientation=landscape",
    tag: "Catálogo",
    tagColor: "secondary"
  },
];

export const seoArticlePreview = seoArticlesList[0];

export const stats = [
  { value: "5000+", label: "Produtos Indexados" },
  { value: "14", label: "Categorias" },
  { value: "24/7", label: "Atualizações" }
];

export const kaspreadsheetUrl = "https://kaspreadsheet.com";